import { Component, DestroyRef, HostBinding, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivationEnd } from '@angular/router';

import { Meeting } from '@cds/betting-offer/tags';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';

import { MeetingSwitcherToggleService } from './meeting-switcher-toggle.service';

@Component({
    selector: 'ms-meeting-switcher-toggle',
    templateUrl: './meeting-switcher-toggle.component.html',
    standalone: false,
})
export class MeetingSwitcherToggleComponent implements OnInit, OnDestroy {
    meeting: Meeting;
    isEnabled: boolean;

    @HostBinding('class') className = 'meeting-switcher-toggle';

    private readonly destroyRef = inject(DestroyRef);

    constructor(
        public toggleService: MeetingSwitcherToggleService,
        private routerEventsService: RouterEventsService,
    ) {}

    ngOnInit(): void {
        this.routerEventsService.currentActivationEnd.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((route) => this.activationEnded(route));
    }

    private activationEnded(route: ActivationEnd | undefined): void {
        this.meeting = <Meeting>route?.snapshot.data['model'].meeting;
        if (!this.meeting) {
            return;
        }
        this.isEnabled = true;
        this.toggleService.closeSwitcher();
    }

    ngOnDestroy(): void {
        this.toggleService.closeSwitcher();
    }

    toggleSwitcher(expanded: boolean): void {
        if (expanded) {
            this.toggleService.closeSwitcher();
        } else {
            this.toggleService.openSwitcher();
        }
    }
}
